/**
 * @module views\sys\db\templates\dynamicProperty
 */
import Vue from "vue";
import Component from "vue-class-component";
import BaseEditor from "../base";
import SelectionPropertys from "./selectionPropertys/selectionPropertys";
import ActionsProperty from "./actionsProperty/actionsProperty";
import { Watch } from "vue-property-decorator";
import OtherProperty from "./otherProperty/otherProperty";
import NumberProperty from "./numberProperty/numberProperty";

@Component({
  components: {
    ["prp-selection"]: SelectionPropertys,
    ["prp-actions"]: ActionsProperty,
    ["prp-other"]: OtherProperty,
    ["prp-number"]: NumberProperty
  }
})
export default class DynamicProperty extends BaseEditor {
  private type = "";

  @Watch("model.type", { deep: true })
  private updateType() {
    let prp = this.model.type;
    if (prp) {
      if (prp === "selection") {
        this.type = "prp-selection";
      } else if (prp === "actions" || prp === "O-sort") {
        this.type = "prp-actions";
      } else if (prp === "image") {
        this.type = "prp-other";
      } else if (prp === "number") {
        this.type = "prp-number";
      } else {
        this.type = "";
      }
    }
  }
}
